module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group input-group--focused input-group--dirty input-group--text-field input-group--select primary--text",
    attrs: {
      "role": "combobox"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('div', {
    staticClass: "input-group__selections"
  }, [_c('date-picker', {
    attrs: {
      "clearable": false,
      "format": "YYYY-MM-DD",
      "not-before": _vm.disableBefore,
      "not-after": _vm.disableAfter,
      "lang": "en"
    },
    on: {
      "change": _vm.triggerUpdate
    },
    model: {
      value: (_vm.dateValue),
      callback: function($$v) {
        _vm.dateValue = $$v
      },
      expression: "dateValue"
    }
  })], 1)])])
},staticRenderFns: []}